import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'discovery_recommendations-infra_page_image_urls_view-action_category_impression';

/**
 * Tracks image urls loaded on a page for performance analysis
 */
export function trackDiscoveryRecommendationsInfraPageImageUrlsViewActionCategoryImpression(
  imageUrls_string: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { imageUrls_string },
  });
}
